export default __webpack_public_path__ + "static/media/radio_off.29931807.svg";